<template>
  <el-dialog
    :title="$t('deleteAttrSpec.confirmTitle')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align: center;">
      <p>{{ $t('deleteAttrSpec.confirmContent') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('deleteAttrSpec.cancel') }}</el-button>
      <el-button type="primary" @click="deleteAttrSpec">{{ $t('deleteAttrSpec.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteAttrSpec } from '@/api/dev/attrSpecApi'

export default {
  name: 'DeleteAttrSpec',
  data() {
    return {
      dialogVisible: false,
      deleteAttrSpecInfo: {}
    }
  },
  methods: {
    open(attrSpec) {
      this.deleteAttrSpecInfo = { ...attrSpec }
      this.dialogVisible = true
    },
    handleClose() {
      this.deleteAttrSpecInfo = {}
    },
    deleteAttrSpec() {
      deleteAttrSpec(this.deleteAttrSpecInfo).then(res => {
        console.log(res)
        this.$message.success(this.$t('deleteAttrSpec.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      }).catch(error => {
        console.error('删除失败:', error)
        this.$message.error(error.message || this.$t('deleteAttrSpec.deleteFailed'))
      })
    }
  }
}
</script>